<template>
<div class="payment-cards-component">
  <header class="payment-cards-component__header">
    <h3 class="payment-cards-component__header-title">Мои карты</h3>
    <!-- <div class="invisible flex-grow"/>
    <button
      type="button"
      class="payment-cards-component__header-button"
    >Добавить</button> -->
  </header>
  <transition name="opacity" mode="out-in">
    <!-- Need a wrapper so we can set height for it without breaking `<TransitionExpand>` -->
    <div
      v-if="!cards"
      key="loading"
    >
      <Preloader
        class="payment-cards-component__loading-placeholder"
      />
    </div>
    <p
      v-else-if="cards.length === 0"
      class="payment-cards-component__no-cards-text"
      key="no-cards"
    >Нет сохранённых карт</p>
    <div
      v-else
      class="payment-cards-component__list-wrapper swiper-container"
      v-swiper="swiperParams"
      key="swiper"
    >
      <ol
        class="payment-cards-component__list swiper-wrapper"
      >
        <template>
          <li
            v-for="(c, ind) of cards"
            :key="c.id"
            :style="{
              'background': `${cardBackgroundPattern}, ${cardsInfo[ind].background}`,
              'color': cardsInfo[ind].textColor,
            }"
            class="payment-cards-component__card swiper-slide"
          >
            <p class="payment-cards-component__card-number">
              <span class="payment-cards-component__card-number-dots">••••</span>
              <span class="payment-cards-component__card-number-last-digits">{{ c.card_last_four }}</span>
            </p>
            <img
              v-if="cardsInfo[ind].bankLogo"
              :src="cardsInfo[ind].bankLogo"
              class="payment-cards-component__card-bank"
            >
            <img
              v-if="cardsInfo[ind].paymentSystemLogo"
              :src="cardsInfo[ind].paymentSystemLogo"
              class="payment-cards-component__card-payment-service"
            >
          </li>
        </template>
      </ol>
    </div>
  </transition>
  <button
    @click="onDeleteClick"
    type="button"
    class="payment-cards-component__remove-button"
    :class="{
      'invisible': typeof selectedCardInd !== 'number'
    }"
  ><IconCreditCardCrossed class="payment-cards-component__remove-button-icon"/> Отвязать карту</button>
</div>
</template>

<script>
import axios from '@/zenky'

export default {
  components: {
    Preloader: () => import('@/components/preloaders/Preloader'),
    IconCreditCardCrossed:() => import(
      /* webpackPreload: true */
      '@/assets/images/icons/icon-creditcard-crossed.svg?inline'
    ),
  },
  directives: {
    swiper: {
      async bind(el, binding, vnode) {
        el.classList.add('swiper-not-ready');

        const styleP = import('swiper/css/swiper.min.css');
        const { Swiper } = (await import('./treeshakenSwiper'));
        await styleP;

        if (el.swiperUnbound) return;

        el.classList.remove('swiper-not-ready');
        el.swiper = new Swiper(el, binding.value);

        el.swiperUnwatch = vnode.context.$watch(
          () => vnode.context.cards,
          () => el.swiper.update(),
        );
      },
      unbind(el) {
        if (el.swiper) {
          el.swiperUnwatch();
          el.swiper.destroy();
        } else {
          el.swiperUnbound = true;
        }
      },
    },
  },
  props: {
    cards: {
      validator: v => v instanceof Array || v === null,
      required: true,
    },
  },
  mounted() {
    this.cardBackgroundPattern = getComputedStyle(this.$el).getPropertyValue('--_card-background-pattern');
  },
  methods: {
    async onDeleteClick() {
      // TODO cancel deletion instead of delete confirmation.
      if (!confirm('Вы уверены, что хотите удалить эту карту?\nВы всегда сможете прикрепить её снова.')) return;
      await axios.delete(`/profile/card-tokens/${this.cards[this.selectedCardInd].id}`);
      this.$emit('request-reload');
    }
  },
  computed: {
    swiperParams() {
      const component = this;
      return {
        spaceBetween: 8, // 'margin.1'
        slidesPerView: 'auto',
        centeredSlides: true,
        on: {
          init() {
            component.selectedCardInd = this.realIndex; // But it's null until Swiper is loaded. TODO?
          },
          slideChange() {
            component.selectedCardInd = this.realIndex;
          },
        },
        grabCursor: true,
      };
    },
    /**
     * @returns {Array<{
     *   textColor: string,
     *   background: string,
     *   bankLogo: string | null,
     *   paymentSystemLogo: string | null,
     * }>}
     */
    cardsInfo() {
      return this.cards.map(c => {
        const src =
          c.bank
          || {
            background_colors: ['#333333', '#222222'],
            logo_style: 'colored',
            logos: {},
            text_color: 'var(--color-light)', // TODO import from Tailwind config.
            payment_system: null,
          };
        return {
          textColor: src.text_color,
          background: `linear-gradient(135deg, ${src.background_colors.join(', ')}`,
          bankLogo: src.logos.svg || src.logos.png || null,
          paymentSystemLogo: src.payment_system?.logos[src.logo_style] || null,
        };
      });
    },
  },
  watch: {
    cards(n) {
      // In general Swiper is in charge for this, but in this case it's not rendered, so we have to do it ourselves.
      if (n?.length === 0) this.selectedCardInd = null;
    },
  },
  data() {
    return {
      selectedCardInd: null,
      cardBackgroundPattern: null,
    };
  },
}
</script>

<style lang="less">
@import '../../pages/profile/common.less';

@r: payment-cards-component;
.payment-cards-component {
  --_card-background-pattern: @payment-card[background-pattern];
  &__header:extend(.profile__card-header) {}
  &__header-title:extend(.profile__card-header-title) {}
  // &__header-button:extend(.profile__card-header-button) {}
  @list-margin-y: theme('margin.4');
  &__list-wrapper {
    margin-top: @list-margin-y;
    margin-bottom: @list-margin-y;
  }
  &__list {
    .swiper-not-ready & {
      @apply overflow-x-auto cursor-auto;
      .@{r}__card {
        @apply mx-1;
      }
    }
  }
  &__card {
    @apply p-5;
    flex-basis: @payment-card[width];
    max-width: calc(100% - theme('padding.2'));
    min-height: @payment-card[min-height];
    border-radius: @payment-card[border-radius];
    display: grid;
    grid-template-areas:
      "bank bank"
      "number payment-service";
    grid-template-columns: auto minmax(20%, 45%);
  }
  &__card-number {
    @apply font-semibold text-base leading-none;
    align-self: end;
    letter-spacing: 0.3ch;
    grid-area: number;
  }
  &__card-number-dots {
    @apply font-black;
    letter-spacing: 0.6ch;
  }
  &__card-bank {
    grid-area: bank;
    height: theme('height.8');
    object-fit: contain;
    object-position: top left;
  }
  &__card-payment-service {
    grid-area: payment-service;
    place-self: end;
    height: theme('height.8');
    object-fit: contain;
    object-position: bottom right;
  }
  .placeholder {
    height: @payment-card[min-height];
    margin-top: @list-margin-y;
    margin-bottom: @list-margin-y;
  }
  &__no-cards-text {
    @apply flex items-center justify-center;
    .placeholder();
  }
  &__loading-placeholder {
    .placeholder();
  }
  &__remove-button {
    @apply text-primary font-semibold text-xs p-1 my-3 block mx-auto;
  }
  &__remove-button-icon {
    @apply fill-current text-primary w-4 inline;
  }
}
</style>
